<script setup lang="ts">
import { defineProps } from 'vue';

const props = defineProps<{
  show: boolean;
}>();
</script>

<template>
  <div v-if="props.show" class="mt-s flex items-center justify-center rounded-12 bg-error-light px-s py-[12px]">
    <div class="flex items-center gap-s">
      <span>🙁 Your subscription deactivated. Please check your payment details. </span>

      <router-link :to="`/settings#workspaces`">
        <span class="button button-colored h-[32px] !px-m">
          <span class="button__text">Settings</span>
        </span>
      </router-link>
    </div>
  </div>
</template>
